export function isElementInViewport(el: any) {
    const rect = el?.getBoundingClientRect();
    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
}
export function scrollToElementToCenter(el: any) {
    if (!el) return;
    el.scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "nearest",
    });
}
export default function scrollToElementIfNeeded(el: any) {
    if (!el) return;
    if (true || !isElementInViewport(el)) {
        el.scrollIntoView({
            behavior: "smooth",
            block: "center",
            inline: "nearest",
        });
    }
}
export function scrollToElementIfReallyNeeded(el: any) {
    if (!el) return;
    if (!isElementInViewport(el)) {
        el.scrollIntoView({
            behavior: "smooth",
            block: "center",
            inline: "nearest",
        });
    }
}
